import { Flex, Box, Icon, Heading, Text, Divider } from "@chakra-ui/react";
import { FaCheck, FaSeedling } from "@onemind-services-llc/react-icons-ng/fa";
import { SectionDivider } from "app/components/shared/SectionDivider";
import RenderBuyNow from "app/pricing/learningLabsTable/components/renderBuyNow";
import { ENTERPRISE_DATA } from "app/pricing/learningLabsTable/enterprise/constants";
import { CISCO_SD_WAN_PRICING_CARD_LIST } from "./constants";

const CiscoSdWanPricing = () => {
  const ciscoSdData = ENTERPRISE_DATA.find((data) => data.labSku === "Cisco SD-WAN LAB");
  if (!ciscoSdData) {
    return <p>No data found</p>;
  }
  const { id, category_id, duration, labSku, price, product_id } = ciscoSdData;
  return (
    <Box id="section-pricing">
      <SectionDivider label="Cisco SD-WAN Pricing" />
      <Flex justifyContent={"center"} mt={5} mb={5} data-cy="section-pricing">
        <Box
          w={{ base: "full", sm: "400px" }}
          boxShadow={"md"}
          border={"1px solid #aaa"}
          borderRadius={"8px"}
          transition={"0.15s"}
          _hover={{
            transform: "scale(1.03)",
            boxShadow: "lg",
          }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={"15px"}
          padding={"15px"}
        >
          <Icon as={FaSeedling} color={"brand.100"} fontSize={"30px"} />
          <Text fontWeight={"bold"}>{duration} Days</Text>
          <Heading color={"primary.200"}>${price}</Heading>
          {CISCO_SD_WAN_PRICING_CARD_LIST.map((list, index) => {
            return (
              <>
                <Flex key={index} gap={"4px"}>
                  <Icon as={FaCheck} fontSize={"20px"} color={"#61CE70"} />
                  <Text>{list}</Text>
                </Flex>
                <Divider _last={{ display: "none" }} borderWidth={"1px"} />
              </>
            );
          })}
          {id && product_id && category_id && (
            <RenderBuyNow
              id={id}
              display={labSku}
              product_id={product_id}
              category_id={category_id}
            />
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default CiscoSdWanPricing;
